import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { env } from "../utils/env";
import { ROUTE } from "../routes";
import { useNavigate } from "react-router-dom";
import { Consultant } from "../types/Consultant";

const fetchConsultant = (authHeader: string, id: number) => () =>
  axios.get<Consultant>(`${env.verifyServiceUrl}individual/mandate_consultant/${id}/`, {
    headers: {
      Authorization: authHeader,
    },
  });

export const useConsultantDetailById = (id, enabled: boolean) => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery(["consultantDetails", id], fetchConsultant(authHeader, id), {
    enabled, retry: false,
    onError: (err: any) => {
      if(err.request.status === 500 || err.request.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
    }
  });
};
